import { Button } from 'antd'

import { forbiddenAuctionApplyApi } from '@eastcoal/api/trade/applyOperation/forbiddenAuctionApply'

import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { pick } from '@eastcoal/common/utils/object'

import { CrudPopform } from '@eastcoal/formily/components/CrudPopform'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { ApplyStatus } from '@eastcoal/shared/enums/ApplyStatus'

import { ApplyForbidButtonProps } from './interface'

const schema: SchemaItem[] = [
  {
    name: 'id',
    type: 'string',
    'x-display': 'hidden'
  },
  {
    name: 'reason',
    title: '原因',
    type: 'string',
    required: true,
    'x-decorator': FormItem,
    'x-component': TextArea
  }
]

export const ApplyForbidButton = ({ record }: ApplyForbidButtonProps) => {
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  return record.status === ApplyStatus.APPLY_SUCCESS ? (
    <CrudPopform
      api={forbiddenAuctionApplyApi}
      name='applyForbidForm'
      schema={schema}
      title='邀约禁用'
      type='warning'
      initialValues={{
        id: record.id
      }}
      onSuccess={() => reload()}
    >
      <Button danger type='link'>
        禁用
      </Button>
    </CrudPopform>
  ) : null
}
